class FideicomisoNoEmpresarialRequestInputTransformer {
  getName() {
    return 'Fideicomisonoempresarial';
  }

  make(data) {
    const { Complemento = {} } = data;

    if (!Complemento.Fideicomisonoempresarial) {
      return data;
    }

    const Fideicomisonoempresarial = { ...Complemento.Fideicomisonoempresarial };

    let { DeduccOSalidas = {} } = Fideicomisonoempresarial;
    let { IngresosOEntradas = {} } = Fideicomisonoempresarial;

    data.Complemento = {
      ...Complemento,
      Fideicomisonoempresarial: {
        ...Fideicomisonoempresarial,
        IngresosOEntradas: {
          ...IngresosOEntradas,
          Concepto: undefined,
          IntegracIngresos: {
            Concepto: IngresosOEntradas.Concepto,
          },
        },
        DeduccOSalidas: {
          ...DeduccOSalidas,
          ConceptoS: undefined,
          IntegracEgresos: {
            ConceptoS: DeduccOSalidas.ConceptoS,
          },
        },
      },
    };

    return data;
  }
}

export default FideicomisoNoEmpresarialRequestInputTransformer;
